(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-detail-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ROOT_SELECTOR = '[data-product-tabs-root]';
    const TRIGGER_SELECTOR = '[data-product-tab-trigger]';
    const PANEL_SELECTOR = '[data-product-tab-panel]';
    const INGREDIENTS_ACCORDION_SELECTOR = '[data-ingredients-accordion]';
    const INGREDIENTS_TRIGGER_SELECTOR = '[data-ingredients-accordion-trigger]';
    const INGREDIENTS_PANEL_SELECTOR = '[data-ingredients-accordion-panel]';

    const setActiveTab = (root, tabId) => {
      root.querySelectorAll(TRIGGER_SELECTOR).forEach((trigger) => {
        const isActive = trigger.dataset.tabId === tabId;
        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
        trigger.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      root.querySelectorAll(PANEL_SELECTOR).forEach((panel) => {
        const isActive = panel.dataset.tabPanel === tabId;
        panel.classList.toggle('hidden', !isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    };

    const initIngredientsAccordion = (scope) => {
      const accordions = scope.matches?.(INGREDIENTS_ACCORDION_SELECTOR)
        ? [scope]
        : Array.from(scope.querySelectorAll?.(INGREDIENTS_ACCORDION_SELECTOR) ?? []);

      accordions.forEach((accordion) => {
        if (accordion.dataset.ingredientsAccordionInitialized === 'true') {
          return;
        }

        const trigger = accordion.querySelector(INGREDIENTS_TRIGGER_SELECTOR);
        const panel = accordion.querySelector(INGREDIENTS_PANEL_SELECTOR);

        if (!trigger || !panel) {
          return;
        }

        panel.classList.remove('hidden');

        trigger.addEventListener('click', () => {
          const isOpen = accordion.classList.toggle('is-other-ingredients-open');
          panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
          trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });

        accordion.dataset.ingredientsAccordionInitialized = 'true';
      });
    };

    const initRoot = (root) => {
      if (!root || root.dataset.tabsInitialized === 'true') {
        return;
      }

      const triggers = Array.from(root.querySelectorAll(TRIGGER_SELECTOR));
      const firstTrigger = triggers[0];

      if (!firstTrigger) {
        return;
      }

      setActiveTab(root, firstTrigger.dataset.tabId);

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          setActiveTab(root, trigger.dataset.tabId);
        });
      });

      root.addEventListener('keydown', (event) => {
        const currentIndex = triggers.findIndex((trigger) => trigger.getAttribute('aria-selected') === 'true');

        if (currentIndex < 0) {
          return;
        }

        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight') {
          nextIndex = (currentIndex + 1) % triggers.length;
        } else if (event.key === 'ArrowLeft') {
          nextIndex = (currentIndex - 1 + triggers.length) % triggers.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = triggers.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        const nextTrigger = triggers[nextIndex];
        setActiveTab(root, nextTrigger.dataset.tabId);
        nextTrigger.focus();
      });

      root.dataset.tabsInitialized = 'true';
    };

    const initTabs = (scope = document) => {
      if (scope.matches?.(ROOT_SELECTOR)) {
        initRoot(scope);
        initIngredientsAccordion(scope);
        return;
      }

      scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initRoot);
      initIngredientsAccordion(scope);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initTabs(document), { once: true });
    } else {
      initTabs(document);
    }

    if (window.__llProductDetailTabsSectionEventsBound === true) {
      return;
    }

    document.addEventListener('shopify:section:load', (event) => {
      initTabs(event.target);
    });

    window.__llProductDetailTabsSectionEventsBound = true;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-testimonials"] && !Shopify.designMode) return;
  try {
    
  function initProductTestimonials(root) {
    if (!root || root.dataset.productTestimonialsReady === 'true') return;

    var rail = root.querySelector('[data-product-testimonials-rail]');
    var prevButton = root.querySelector('[data-product-testimonials-prev]');
    var nextButton = root.querySelector('[data-product-testimonials-next]');

    if (!rail || !prevButton || !nextButton) return;

    root.dataset.productTestimonialsReady = 'true';

    var getScrollStep = function () {
      var firstCard = rail.querySelector('article');
      var styles = window.getComputedStyle(rail);
      var gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;

      return firstCard ? firstCard.getBoundingClientRect().width + gap : rail.clientWidth;
    };

    var updateControls = function () {
      var maxScroll = rail.scrollWidth - rail.clientWidth - 1;

      prevButton.disabled = rail.scrollLeft <= 1;
      nextButton.disabled = rail.scrollLeft >= maxScroll;
    };

    var scrollByCard = function (direction) {
      rail.scrollBy({
        left: getScrollStep() * direction,
        behavior: 'smooth',
      });
    };

    prevButton.addEventListener('click', function () {
      scrollByCard(-1);
    });

    nextButton.addEventListener('click', function () {
      scrollByCard(1);
    });

    rail.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    updateControls();
  }

  function initAllProductTestimonials(container) {
    var scope = container || document;
    var sections = scope.querySelectorAll('[data-product-testimonials]');

    sections.forEach(initProductTestimonials);
  }

  initAllProductTestimonials();

  document.addEventListener('shopify:section:load', function (event) {
    initAllProductTestimonials(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
